import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { APICallService } from 'src/app/services/api-call.service';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { AgentLovComponent } from '../../common/agent-lov/agent-lov.component';
import { SrcExtLovComponent } from '../../common/src-ext-lov/src-ext-lov.component';

@Component({
  selector: 'src-ext-per-dealership-maintenance',
  templateUrl: './src-ext-per-dealership-maintenance.component.html',
  styleUrls: ['./src-ext-per-dealership-maintenance.component.css']
})
export class SrcExtPerDealershipMaintenanceComponent implements OnInit, LeaveConfirmation {
  
  moduleId: string = 'BMM186';
  public moduleName: string = this._jDS.data.moduleList.find((a: any) => a.moduleId === this.moduleId)?.moduleDesc?.toUpperCase() ?? "";

  constructor(
    private fb: FormBuilder,
    private _matDialog: MatDialog,
    private _api: APICallService,
    public _formService: FormService,
    private _jDS: JsonDataService,
    private _userDetailService: UserDetailsService,
    private _securityService: SecurityService
  ) { 
    this.userIdLoggedIn = this._userDetailService.userId ?? "";
  }

  ngOnInit(): void {
    this.btns.srcExtPerDealership.addDisabled = true;
  }

  canDeactivate(): boolean | Observable<boolean> {
    if(this.tempData!='') {
      return false;
    } else {
      return true;
    }
  }

  /* Boolean Stuffs */

  public btns = {
    srcExtPerDealership: {
      addDisabled: true,
      updateDisabled: true,
      deleteDisabled: true,
      saveDisabled: true,
      srcExtDisabled: true
    }
  }

  public selections = {
    activeTypes: [
      { cd: 'A', name: 'Yes' },
      { cd: 'I', name: 'No' },
    ]
  }

  public showForm: boolean = true;

  private rowData: any;
  private tempDataRow: any;
  private errorMessage: string = "";
  private userIdLoggedIn: string;
  private tempData: any = [];

  public forms = {
    agentLovForm: this.fb.group({
      agentCd: [null],
      agentName: [null],
      agentCdDisp: [{ value: '', disabled: 'true' }],
    }),
    srcExtPerDealershipForm: this.fb.group({
      agentCd: [null],
      srcExtCd: [null, [Validators.required]],
      srcExtDisp: [null],
      srcExtDesc: [null],
      srcExtField: [{ value: '', disabled: 'true' }, [Validators.required]],
      remarks: [null, [Validators.maxLength(4000)]],
      activeTag: ['A', [Validators.required]],
      lastUser: [{ value: '', disabled: 'true' }],
      lastUpdate: [{ value: '', disabled: 'true' }]
    }),
    resetSrcExtPerDealershipForm: () => {
      this.forms.srcExtPerDealershipForm.reset();
      this.forms.srcExtPerDealershipForm.patchValue({
        activeTag: 'A',
        agentCd: this.forms.agentLovForm.get('agentCd')?.value
      });
      this.btns.srcExtPerDealership.updateDisabled = true;
      this.btns.srcExtPerDealership.deleteDisabled = true;
      this.btns.srcExtPerDealership.srcExtDisabled = false;
      this._formService.hideFormMsg("src-ext-per-dealership-error-message");
      this.rowData = null;
    },
    resetAgentLovForm: () => {
      this.forms.agentLovForm.reset();
    },
    resetAllForms: () => {
      this.forms.resetAgentLovForm();
      this.forms.resetSrcExtPerDealershipForm();
    }
  }

  private srcExtPerDealershipFormManipulate = {
    dbToForm: (data: any) => {
      return {
        srcExtCd: data.SRC_EXT_CD,
        srcExtDisp: data.SRC_EXT_DISP,
        srcExtDesc: data.SRC_EXT_DESC,
        srcExtField: data.SRC_EXT_CD?.toString().padStart(2, 0) + " - " + data.SRC_EXT_DESC,
        activeTag: data.ACTIVE_TAG,
        remarks: data.REMARKS,
        lastUser: data.LAST_USER,
        lastUpdate: data.LAST_UPDATE,
      };
    },
    formToDb: (data: any, mode: any) => {
      return {
        AGENT_CD: data.agentCd,
        SRC_EXT_CD: data.srcExtCd,
        SRC_EXT_DISP: data.srcExtCd?.toString().padStart(2, 0),
        SRC_EXT_DESC: data.srcExtDesc,
        SRC_EXT_FIELD: data.srcExtCd + " - " + data.srcExtDesc,
        ACTIVE_TAG: data.activeTag,
        REMARKS: data.remarks,
        LAST_USER: this.userIdLoggedIn,
        LAST_UPDATE: null,
        MODE: mode
      };
    }
  }

  public srcExtPerDealershipTblConfig = {
    cols: [
      {
        key: "SRC_EXT_DISP",
        header: "Source Extension",
        dataType: "string",
        width: '20%'
      },
      {
        key: "SRC_EXT_DESC",
        header: "Source Extension Description",
        dataType: "string"
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '64px'
      }
    ],
    tblData: [] as any[],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }

  public openLov = {
    agent: () => {
      const LOVOPTIONS: { [key: string]: any } = {
        disableClose: true,
        width: '512px',
        data: {
          moduleId: this.moduleId
        },
      };
      this._matDialog.open(AgentLovComponent, LOVOPTIONS).afterClosed().subscribe((lovData: any) => {
        if (lovData?.button === 'OK') {
          if (lovData?.content?.AGENT_CD) {
            let data = lovData?.content;
            this.forms.agentLovForm.patchValue({
              agentCd: data.AGENT_CD,
              agentName: data.AGENT_NAME,
              agentCdDisp: `${data.AGENT_CD} - ${data.AGENT_NAME}`,
            });
            this.forms.resetSrcExtPerDealershipForm();
            this.getData.srcExtPerDealership();
          }
          else {
            this.forms.agentLovForm.patchValue({
              agentCd: null,
              agentName: null,
              agentCdDisp: null,
            });
          }
        }
      });
    },
    srcExt: () => {
      let srcExtCdExists: any[] = this.srcExtPerDealershipTblConfig.tblData.map((row: any) => { return +row.SRC_EXT_CD; }).filter(Boolean);
      const LOVOPTIONS: { [key: string]: any } = {
        disableClose: true,
        width: '512px',
        data: {
          col: 'CD',
          moduleId: this.moduleId,
          lpad: 2,
          srcExtExclude: srcExtCdExists
        }
      };
      this._matDialog.open(SrcExtLovComponent, LOVOPTIONS).afterClosed().subscribe((lovData: any) => {
        if (!lovData.option) {
          if (lovData?.content?.SRC_EXT_CD) {
            const data = lovData?.content;
            this.forms.srcExtPerDealershipForm.patchValue({
              srcExtCd: data.SRC_EXT_CD?.toString().padStart(2, 0),
              srcExtDesc: data.SRC_EXT_DESC,
              srcExtField: `${data.SRC_EXT_CD?.toString().padStart(2, 0)} - ${data.SRC_EXT_DESC}`,
            });
          }
          else {
            this.forms.srcExtPerDealershipForm.patchValue({
              srcExtCd: null,
              srcExtDesc: null,
              srcExtField: null,
            });
          }
        }
      });
    }
  };

  private getData = {
    srcExtPerDealership: () => {
      try {
        this.srcExtPerDealershipTblConfig.tblData = [];
        this.srcExtPerDealershipTblConfig.loading = true;
        this._jDS.contorlLoading(true);
        this._api.getSrcExtPerDealership({
          moduleId: this.moduleId,
          userId: this._userDetailService.userId,
          type: "MODULE"
        }).subscribe({
          next: (data: any) => {
            this._securityService.checkRequestKeyResponse(data, () => {
              this._securityService.hasValidCsrfToken(data, () => {
                let content = JSON.parse(this._jDS.decrypt(data.response));
                this._jDS.contorlLoading(false);
                this.srcExtPerDealershipTblConfig.tblData = content.data.filter((d: any) => 
                d.AGENT_CD == this.forms.agentLovForm.get('agentCd')?.value);
                this.btns.srcExtPerDealership.addDisabled = false;
                this.tempData = [];
                this.btns.srcExtPerDealership.saveDisabled = true;
                this.srcExtPerDealershipTblConfig.loading = false;
              });
            });
          },
          error: (error: any) => {
            this.srcExtPerDealershipTblConfig.loading = false;
            this._jDS.contorlLoading(false);
          }
        });
      }
      catch (e) {
        console.error(e);
      }
    }
  }

  onRowClick(ev: any) {
    try {
      ev.update = true;
      this.rowData = ev;
      this.populateFormFromTable();
    }
    catch (e) {
      this.forms.resetSrcExtPerDealershipForm();
      this.rowData = null;
      //this.indexRow = null;
    }
  }

  populateFormFromTable() {
    try {
      let data = this.rowData;
      this.btns.srcExtPerDealership.srcExtDisabled = true;
      this.btns.srcExtPerDealership.updateDisabled = !data.update;
      this.btns.srcExtPerDealership.deleteDisabled = !data.temp;
      this.tempDataRow = !data.temp;
      this.forms.srcExtPerDealershipForm.patchValue(this.srcExtPerDealershipFormManipulate.dbToForm(data));
    }
    catch (e) {
      console.error(e);
    }
  }

  public onAdd() {
    try {
      this._formService.hideFormMsg("src-ext-per-dealership-error-message");
      if (this.forms.srcExtPerDealershipForm.valid) {
        let rowToBeAdded: { [key: string]: any } = this.srcExtPerDealershipFormManipulate.formToDb(this.forms.srcExtPerDealershipForm.value, 'I');
        rowToBeAdded.temp = true;
        this.tempData.push(rowToBeAdded);
        this.srcExtPerDealershipTblConfig.tblData = [rowToBeAdded, ...this.srcExtPerDealershipTblConfig.tblData];
        this.forms.resetSrcExtPerDealershipForm();
        this.btns.srcExtPerDealership.saveDisabled = false;
      }
      else {
        this.showErrorValidator.srcExtPerDealership();
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  public onDelete() {
    try {
      let clickData = this.rowData;
      this.srcExtPerDealershipTblConfig.tblData = this.srcExtPerDealershipTblConfig.tblData.filter((d: any) => {
        return d !== this.rowData;
      });
      this.tempData = this.tempData.filter(
        function(e: any) {
          return e.SRC_EXT_CD != clickData.SRC_EXT_CD;
        }
      );
      if (this.tempData==null || this.tempData=='') {
        this.btns.srcExtPerDealership.saveDisabled = true;
      }
      this.forms.resetSrcExtPerDealershipForm();
    }
    catch (e) {
      console.error(e);
    }
  }

  public onUpdate() {
    try {
      this._formService.hideFormMsg("src-ext-per-dealership-error-message");
      if (this.forms.srcExtPerDealershipForm.valid) {
        this.forms.srcExtPerDealershipForm.get('srcExtField')?.enable();
        let clickData = this.rowData;
        let toBeUpdatedIndex = this.srcExtPerDealershipTblConfig.tblData.indexOf(this.rowData);
        let srcExtPerDealershipCdRowValue = this.rowData.SRC_EXT_CD;
        let rowToBeUpdated: { [key: string]: any } = this.srcExtPerDealershipFormManipulate.formToDb(this.forms.srcExtPerDealershipForm.value, 'U');
        this.forms.srcExtPerDealershipForm.get('srcExtField')?.disable();
        let tempInsertChecker = this.tempData.find(
          (m: { SRC_EXT_CD: any }) => 
            m.SRC_EXT_CD == clickData.SRC_EXT_CD && clickData.MODE == 'I');
        let tempUpdateChecker = this.tempData.find(
          (m: { SRC_EXT_CD: any }) => 
            m.SRC_EXT_CD == clickData.SRC_EXT_CD && clickData.MODE == 'U');
        if (this.rowData.temp) {
          rowToBeUpdated.temp = true;
        }
        else {
          rowToBeUpdated.onDbButUpdatedTemp = true;
          rowToBeUpdated.SRC_EXT_CD = srcExtPerDealershipCdRowValue;
        }
        if (tempInsertChecker!=null && tempInsertChecker!='') {
          //tempInsertChecker = rowToBeUpdated;
          tempInsertChecker.ACTIVE_TAG = rowToBeUpdated.ACTIVE_TAG;
          tempInsertChecker.REMARKS = rowToBeUpdated.REMARKS;
          tempInsertChecker.USER_ID = rowToBeUpdated.USER_ID;
          tempInsertChecker.MODE = 'I';
          rowToBeUpdated.MODE = 'I';
        }
        else if (tempUpdateChecker!=null && tempUpdateChecker!='') {
          tempUpdateChecker.ACTIVE_TAG = rowToBeUpdated.ACTIVE_TAG;
          tempUpdateChecker.REMARKS = rowToBeUpdated.REMARKS;
          tempUpdateChecker.USER_ID = rowToBeUpdated.USER_ID;
          tempUpdateChecker.MODE = 'U';
        }
        else { 
          this.tempData.push(rowToBeUpdated);
        }
        this.forms.resetSrcExtPerDealershipForm();
        this.srcExtPerDealershipTblConfig.tblData[toBeUpdatedIndex] = rowToBeUpdated;
        this.btns.srcExtPerDealership.saveDisabled = false;
        this.srcExtPerDealershipTblConfig.tblData = [... this.srcExtPerDealershipTblConfig.tblData];
      }
      else {
        this.showErrorValidator.srcExtPerDealership();
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  public onSave() {
    try {
      this.btns.srcExtPerDealership.saveDisabled = true;
      this.showForm = false;
      this._formService.showFormLoader(null, "src-ext-per-dealership-maintenance-loading", "Saving.<br>Please wait ...", null, null);
      if (this.tempData.length > 0) {
        this._api.saveSrcExtPerDealership(this.tempData).subscribe({
          next: (data: any) => {
            this._securityService.checkRequestKeyResponse(data, () => {
              this._securityService.hasValidCsrfToken(data, () => {
                if (data.status === 'SUCCESS') {
                  this.onComplete.srcExtPerDealership();
                }
                else {
                  this.onComplete.srcExtPerDealershipError();
                }
              });
            });
          },
          error: (data: any) => {
            this.onComplete.srcExtPerDealershipError();
          },
        });
      }
      else
        this.onComplete.srcExtPerDealership();
    }
    catch (e) {
      console.error(e);
    }
  }

  private onComplete = {
    srcExtPerDealership: () => {
      this.getData.srcExtPerDealership();
      this.showForm = true;
      this._formService.hideFormLoader("src-ext-per-dealership-maintenance-loading");
      this.forms.resetSrcExtPerDealershipForm();
      this.openDialog('SUCCESS', 'Source Extension Code Per Dealership successfully saved');
    },
    srcExtPerDealershipError: () => {
      this.showForm = true;
      this.btns.srcExtPerDealership.saveDisabled = false;
      this.openDialog('FAILED', 'Source Extension Code Per Dealership saving failed');
      this._formService.hideFormLoader("src-ext-per-dealership-maintenance-loading");
    },
  }

  openDialog(title: any, message: any) {
    try {
      this.showForm = true;
      this._formService.hideFormLoader("src-ext-per-dealership-maintenance-loading");
      this._matDialog.open(DialogMsgComponent, { 
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        } 
      });
    } catch(e) {
      console.error(e);
    }
  }

  public showErrorValidator = {
    srcExtPerDealership: () => {
      try {
        Object.keys(this.forms.srcExtPerDealershipForm.controls).forEach(key => {
          const controlErrors = this.forms.srcExtPerDealershipForm.get(key)?.errors;
          if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
              if (keyError == 'required' && controlErrors[keyError] === true)
                this.errorMessage = "There are missing information. Please provide necessary information needed.";
            });
          }
        });
        this._formService.showFormMsg("src-ext-per-dealership-error-message", this.errorMessage, "E");
        //this.openDialog('ERROR', this.errorMessage);
        setTimeout(()=>{                           
          this._formService.hideFormMsg("src-ext-per-dealership-error-message");
        }, 10000);
      }
      catch (e) {
        console.error(e);
      }
    },
  }

}
